import { trackBillingCheckoutStarted } from "@/lib/analytics/billing-analytics"
import { isApiSuccessBody } from "@/lib/api/api-envelope"
import type { ApiBillingCheckoutPayload } from "@/lib/api/billing-contract"

export async function requestStorageChunkCheckoutUrl(): Promise<
  { ok: true; url: string } | { ok: false; message: string }
> {
  const res = await fetch("/api/billing/checkout/storage-chunk", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: "{}",
  })
  const body: unknown = await res.json()
  if (!res.ok || !isApiSuccessBody<ApiBillingCheckoutPayload>(body)) {
    return { ok: false, message: "Checkout is not available right now." }
  }
  const d = body.data
  if (d.status === "ready" && d.url) {
    trackBillingCheckoutStarted({ kind: "storage_addon", plan: "storage_addon" })
    return { ok: true, url: d.url }
  }
  if (d.status === "not_configured") {
    return {
      ok: false,
      message: d.message ?? "Checkout is not configured yet.",
    }
  }
  return { ok: false, message: "Checkout is not configured yet." }
}
